import { useState, useCallback } from 'react';
import { useGameStore, useUIStore } from '@/stores';
import BaseGameSetup from './BaseGameSetup';
import './LocalGameSetup.css';

/**
 * LocalGameSetup - ローカルモードセットアップ画面
 * 同じデバイスで3人プレイ（プレイヤー名入力）
 */
const LocalGameSetup = () => {
  const initializeGame = useGameStore((state) => state.initializeGame);
  const navigateTo = useUIStore((state) => state.navigateTo);

  const [player1Name, setPlayer1Name] = useState('プレイヤー 1');
  const [player2Name, setPlayer2Name] = useState('プレイヤー 2');
  const [player3Name, setPlayer3Name] = useState('プレイヤー 3');
  const [error, setError] = useState('');

  /**
   * 入力検証
   */
  const validateInputs = useCallback(() => {
    if (!player1Name.trim() || !player2Name.trim() || !player3Name.trim()) {
      setError('全てのプレイヤー名を入力してください');
      return false;
    }

    const names = [player1Name.trim(), player2Name.trim(), player3Name.trim()];
    const uniqueNames = new Set(names);
    if (uniqueNames.size !== names.length) {
      setError('プレイヤー名は重複できません');
      return false;
    }

    setError('');
    return true;
  }, [player1Name, player2Name, player3Name]);

  /**
   * ゲーム開始ハンドラ
   */
  const handleStartGame = useCallback(() => {
    if (!validateInputs()) return;

    const playerNames = [
      player1Name.trim(),
      player2Name.trim(),
      player3Name.trim(),
    ];

    // ゲームを初期化（ローカルモード）
    // localPlayerId は player.id ('1', '2', '3') であり、player name ではない
    initializeGame('local', playerNames, '1');

    // ゲームボード画面に遷移
    navigateTo('game_board');
  }, [player1Name, player2Name, player3Name, validateInputs, initializeGame, navigateTo]);

  return (
    <BaseGameSetup
      mode="local"
      title="ローカルプレイ"
      description="同じデバイスで3人でプレイします。各プレイヤーの名前を入力してください。"
    >
      <div className="LocalGameSetup">
        {/* プレイヤー名入力 */}
        <div className="LocalGameSetup__players">
          <div className="LocalGameSetup__player-input">
            <label className="LocalGameSetup__label" htmlFor="player1">
              プレイヤー 1
            </label>
            <input
              id="player1"
              type="text"
              className="LocalGameSetup__input"
              value={player1Name}
              onChange={(e) => setPlayer1Name(e.target.value)}
              placeholder="名前を入力"
              maxLength={20}
            />
          </div>

          <div className="LocalGameSetup__player-input">
            <label className="LocalGameSetup__label" htmlFor="player2">
              プレイヤー 2
            </label>
            <input
              id="player2"
              type="text"
              className="LocalGameSetup__input"
              value={player2Name}
              onChange={(e) => setPlayer2Name(e.target.value)}
              placeholder="名前を入力"
              maxLength={20}
            />
          </div>

          <div className="LocalGameSetup__player-input">
            <label className="LocalGameSetup__label" htmlFor="player3">
              プレイヤー 3
            </label>
            <input
              id="player3"
              type="text"
              className="LocalGameSetup__input"
              value={player3Name}
              onChange={(e) => setPlayer3Name(e.target.value)}
              placeholder="名前を入力"
              maxLength={20}
            />
          </div>
        </div>

        {/* エラーメッセージ */}
        {error && <div className="LocalGameSetup__error">{error}</div>}

        {/* 注意事項 */}
        <div className="LocalGameSetup__note">
          <span className="LocalGameSetup__note-tag">NOTICE</span>
          <span className="LocalGameSetup__note-text">
            ローカルプレイでは、ターンごとにデバイスを次のプレイヤーへ渡してください。
          </span>
        </div>

        {/* 開始ボタン */}
        <button className="LocalGameSetup__start-button" onClick={handleStartGame}>
          ゲーム開始
        </button>
      </div>
    </BaseGameSetup>
  );
};

export default LocalGameSetup;
